<template>
  <div class="container is-fluid">
    <div class="level">
        <div class="level-left">
            <h1 class="title ">Add an Historical Application for {{contact.forename}} {{contact.surname}}</h1>
        </div>
        <div class="level-right">
            <div class="buttons  is-right">
            <router-link :to="'/contacts/' + this.$route.params.id + '/applications'"><button class="button is-info">Back to Contact</button></router-link>
        
            </div>
        </div>
    </div>
    <div class="box ">	
      <div class="columns">
          <div class="field column">
            <label class="label">Funding Round</label>
            <div class="select is-fullwidth ">
              <select  v-model="roundId"  required >
                  <option value="">Select Funding Round ...</option>
                  <option v-for="row in rounds" :key="row.id" :value="row.id">{{ row.name }}</option>
              </select>
          </div>
        </div>
      </div>

      <div class="columns">
          <div class="field column">
            <label class="label">Governing Body</label>
            <div class="select is-fullwidth ">
              <select  v-model="governingBodyId" required  >
                  <option value="">Select Governing Body ...</option>
                  <option v-for="row in governing_bodies" :key="row.id" :value="row.id">{{ row.name }}</option>
              </select>
          </div>
        </div>
      </div>
     
      <div class="columns">
          <div class="field column">
            <label class="label">Application Date</label>
            <div class="control ">
             <input v-model="date" type="date" class="input" />
          </div>
        </div>
      </div>
     

      <div class="field is-grouped">
        <p class="control">
          <a class="button is-success" @click.prevent="saveContactApplication()">
            Save
          </a>
         
        </p>
       
      </div>


    </div>
	     

  </div>
</template>

<script>


import ContactService from '@/services/ContactService.js';
import UtilityService from '@/services/UtilityService.js';

import ContactMixin from "@/mixins/ContactMixin.js";


export default {
  components: {
   	
  },
  mixins: [ContactMixin],
  data() {
    return {
      errors: [],
      rounds: [],
      roundId: '',
      date: '',
      governing_bodies: [],
      governingBodyId: '',
     contact: {forename:'', surname:''}
    }
  },
  

  // Fetches posts when the component is created.
  created() {
    this.getAccessToken()
    .then(() => { 
        this.getRounds();
        this.getGoverningBodies();
        this.getContactSingle();
    });
  },
  methods: {
    async saveContactApplication() 
     {
        var formdata = { 
          contact_id: this.$route.params.id,
           round_id : this.roundId,
           date: this.date,
           forename : this.contact.forename,
            surname : this.contact.surname,
            email: this.contact.email,
           governing_body_id: this.governingBodyId,
           historical_application : 1
        }; 

        ContactService.saveContactApplication(this.accessToken, formdata)
        .then(() => { 
          this.$router.push("/contacts/" + this.$route.params.id + '/applications');
          });
        
      },
      async getRounds() {
          UtilityService.getSimpleApiData(this.accessToken, "rounds").then(
          response => this.rounds = response 
          );
      },
      async getGoverningBodies() {
          UtilityService.getSimpleApiData(this.accessToken, "governing_bodies").then(
          response => this.governing_bodies = response 
          );
      },

    }
   
    
}

</script>

<style>
	
</style>
